import styled from "styled-components";

export const LegendContentRight = styled.div`
  position: absolute;
  z-index: 1000;
  top: 0.7rem;
  right: 0.7rem;
  background-color: rgb(255 255 255 / 88%);
  width: 10rem;
`;
